import React, { useEffect, useState } from 'react';
import PageWrapper from '../../../../components/Display/PageWrapper';
import { privateFetch } from '../../../../utils/apiHelper';
import { useAccountContext } from '../../../../contexts/AccountContext';
import { useNavigationContext } from '../../../../contexts/NavigationContext';
import { DataView } from 'primereact/dataview';
import ExternalResourceItem from './ExternalResourceItem';
import ExternalResourceDetail from './ExternalResourceDetail';
import ExternalResourceManager from './ExternalResourceManager';

function ExternalResourcesPage({ isActive }) {
  const { accountContext } = useAccountContext();
  const [externalResourceList, setExternalResourceList] = useState([]);
  const [externalResourceDetail, setExternalResourceDetail] = useState(undefined);
  const [panelIsOpen, setPanelIsOpen] = useState(false);
  const [emptyPayload, setEmptyPayload] = useState(false);
  const { openSYExternalResourceDetail, navigationContext } = useNavigationContext();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    fetchExternalResourceList();
  }, []);

  const fetchExternalResourceList = async () => {
    await privateFetch('GET', 'solarys', `/cu/${accountContext.id}/external-resource/`).then(
      (res) => {
        setExternalResourceList(res);
      }
    );
  };

  const fetchExternalResourceDetail = async () => {
    await privateFetch(
      'GET',
      'solarys',
      `/cu/${accountContext.id}/external-resource/${navigationContext.acitveExternalResourceId}/`
    ).then((res) => {
      if (res) setExternalResourceDetail(res);
    });
  };

  const createExternalResource = async (resourceForm) => {
    setLoading(true);
    await privateFetch(
      'POST',
      'solarys',
      `/cu/${accountContext.id}/external-resource/`,
      "L'évènement a bien été ajouté",
      JSON.stringify(resourceForm)
    ).then(() => {
      fetchExternalResourceList();
      setPanelIsOpen(false);
      setLoading(false);
      setExternalResourceDetail(undefined);
      setEmptyPayload(true);
    });
  };

  const updateExternalResource = async (resourceForm) => {
    setLoading(true);
    await privateFetch(
      'PUT',
      'solarys',
      `/cu/${accountContext.id}/external-resource/${externalResourceDetail.id}/`,
      "L'évènement a bien été modifié",
      JSON.stringify(resourceForm)
    ).then(() => {
      fetchExternalResourceList();
      setPanelIsOpen(false);
      fetchExternalResourceDetail(externalResourceDetail.id);
      setLoading(false);
    });
  };

  const deleteExternalResource = async (resource) => {
    await privateFetch(
      'DELETE',
      'solarys',
      `/cu/${accountContext.id}/external-resource/${resource.id}/`,
      'La ressource externe a bien été supprimée'
    ).then(() => {
      fetchExternalResourceList();
      setExternalResourceDetail(undefined);
    });
  };

  useEffect(() => {
    if (navigationContext.acitveExternalResourceId) {
      fetchExternalResourceDetail();
    } else setExternalResourceDetail(undefined);
  }, [navigationContext.acitveExternalResourceId]);

  const handleOpenManager = () => {
    setPanelIsOpen(true);
    setEmptyPayload(false);
  };

  const handleClickExternalResource = (resource) => {
    openSYExternalResourceDetail(resource);
  };

  const goBackExternalResourceAction = {
    onClick: handleClickExternalResource,
    label: 'Retour à la liste'
  };

  const newExternalResourceAction = {
    onClick: handleOpenManager,
    label: 'Ajouter une ressource',
    icon: 'pi-plus'
  };

  const itemTemplate = (externalResource) => (
    <ExternalResourceItem
      resource={externalResource}
      handleClickResource={() => handleClickExternalResource(externalResource)}
    />
  );

  return (
    <div className={`h-full w-full flex-col ${isActive ? 'flex' : 'hidden'}`}>
      <PageWrapper
        label="Ressources thématiques"
        labelAction={handleClickExternalResource}
        action={externalResourceDetail ? goBackExternalResourceAction : newExternalResourceAction}
        detail={externalResourceDetail}>
        {externalResourceDetail ? (
          <ExternalResourceDetail
            resource={externalResourceDetail}
            handleUpdateResource={handleOpenManager}
            handleDelete={deleteExternalResource}
          />
        ) : (
          <DataView
            value={externalResourceList}
            itemTemplate={itemTemplate}
            className="pb-20"
            emptyMessage="Aucun évènement trouvé"
          />
        )}
      </PageWrapper>
      <ExternalResourceManager
        isOpen={panelIsOpen}
        resource={externalResourceDetail}
        emptyPayload={emptyPayload}
        setPanelIsOpen={setPanelIsOpen}
        setResourceDetail={setExternalResourceDetail}
        loading={loading}
        onCreate={createExternalResource}
        onUpdate={updateExternalResource}
      />
    </div>
  );
}

export default ExternalResourcesPage;
